module.exports = __webpack_public_path__ + "static/media/page_28.11f8e0b3.jpg";